<round-progress 
    [max]="100"
    [current]="progress"
    [radius]="20"
    color="#FA6400"
    [stroke]="5"
></round-progress>